import { webRequest } from '../../client/HttpClient';
import { APIResult } from '../APIResult';
import { logAPIErrorToNewrelic } from '../utils';

interface VariantResponse {
    swatches?: Swatch[];
    sizes: string[];
    skus: VariantSku[];
}

export const GetVariants = async (productId: string): Promise<APIResult<VariantInfo>> => {
    const url = `${process.env.REACT_APP_QUICKVIEW_URL}/${productId}`;
    const res = await webRequest(url, {});

    const result = new APIResult<VariantInfo>();
    result.showError = false;
    if (!res) {
        logAPIErrorToNewrelic(`GetVariants`, `No response`, {
            response: res,
            result: result,
            errorMessage: result.errorMessage,
            showError: result.showError,
            url: url,
            productId: productId,
        });
        return result;
    }

    if (res.ok) {
        result.success = true;
        const data = (await res.json()) as VariantResponse;

        let colours: Colour[] = [];
        if (data.swatches) {
            colours = data.swatches.map((s: Swatch) => ({
                colour: s.label,
                swatchImage: s.imageSrc,
                inStock: true,
            }));
        }
        result.data = {
            colours,
            sizes: data.sizes,
            skus: data.skus,
        };
    } else {
        logAPIErrorToNewrelic(`GetVariants`, `Response Not OK`, {
            ...res,
            result: result,
            errorMessage: result.errorMessage,
            showError: result.showError,
            url: url,
            productId: productId,
        });
    }
    return result;
};
